import React, { useCallback, useState } from 'react'

import { sendPasswordResetEmail } from 'firebase/auth'
import { auth } from '../../firebase/firebase'

import { 
    Alert, 
    Avatar, 
    Button, 
    Grid, 
    Link, 
    Paper, 
    TextField, 
    Typography 
} from '@mui/material'


const ResetPassScreen = () => {

    const paperStyle={padding :40,height:'24vh',width:280, margin:"200px auto"}
    const btnstyle={margin:'8px 0'}
    const textStyle={margin:'5px 0'}

    const [email, setEmail] = useState('')
    const [error, setError] = useState(null)

    const [logrado, setLogrado] = useState(null)

    const procesarDatos = (e) =>{
        e.preventDefault();
        if(!email.trim()){
            setError('Ingresar email');
            return
        }
        
        /* console.log('Pasando todas las validaciones'); */
        setError(null);
        resetPass();
    }
    
    const resetPass = async() =>{
        await sendPasswordResetEmail(auth, email)
            .then(() => {
                    // Password reset email sent!
                    // ..
                    setLogrado('Correo enviado!')
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;

                    if(errorCode==='auth/invalid-email'){
                        setError('Formato del correo no válido')
                    }
                    if(errorCode==='auth/user-not-found'){
                        setError('Correo no registrado')
                    }
                // ..
                });
        
    }
    

    
    return (
        <div>
            {/* <h1>Reset password Screen</h1> */}
            <Grid>
                <Paper elevation={10} style={paperStyle}>

                <Grid align='center'>
                    <h2>Restaurar contraseña</h2>
                </Grid>
                    
                {
                    logrado && (
                        <Alert>{logrado}</Alert>
                    )
                }
                { 
                    error && (
                    <Alert severity="error" >{error}</Alert>
                    )
                }

                <TextField 
                    style={textStyle} 
                    label='Ingresa tu correo'
                    placeholder='Ingresa tu correo' 
                    fullWidth 
                    required
                    onChange={(e)=>{setEmail(e.target.value)}}
                    value={email}
                />
                
                <Button 
                    type='submit' 
                    color='primary' 
                    variant="contained" 
                    style={btnstyle} 
                    fullWidth
                    onClick={procesarDatos}
                >
                    Enviar correo
                </Button>

               {/*  <Typography>
                    <Link href="#" onClick={()=>{console.log('hola')}}>
                    Olvidé mi contraseña
                    </Link>
                </Typography>
                <Typography > No tienes cuenta? 
                    <Link href="/register" >
                        Registrate!
                    </Link>
                </Typography> */}
                </Paper>
            </Grid>
        </div>
    )
}

export default ResetPassScreen